/**
 * Non-linear time limit values for slider
 * Index 0 (left) = 5000ms (easiest)
 * Index 13 (right) = 100ms (hardest)
 * 
 * Values from 5000ms to 1000ms in 1000ms steps,
 * then 1000ms to 100ms in 100ms steps
 */
export const TIME_LIMIT_VALUES = [
  5000,  // 5s
  4000,  // 4s
  3000,  // 3s
  2000,  // 2s
  1000,  // 1s
  900,   // 0.9s
  800,   // 0.8s
  700,   // 0.7s
  600,   // 0.6s
  500,   // 0.5s
  400,   // 0.4s
  300,   // 0.3s
  200,   // 0.2s
  100,   // 0.1s
];

/**
 * Converts a slider index to milliseconds
 */
export const getTimeLimitFromIndex = (index: number): number => {
  return TIME_LIMIT_VALUES[Math.max(0, Math.min(TIME_LIMIT_VALUES.length - 1, index))];
};

/**
 * Converts milliseconds to the closest slider index
 */
export const getIndexFromTimeLimit = (ms: number): number => {
  // Find the closest value
  let closestIndex = 0;
  let closestDiff = Math.abs(TIME_LIMIT_VALUES[0] - ms);
  
  for (let i = 1; i < TIME_LIMIT_VALUES.length; i++) {
    const diff = Math.abs(TIME_LIMIT_VALUES[i] - ms);
    if (diff < closestDiff) {
      closestDiff = diff;
      closestIndex = i;
    }
  }
  
  return closestIndex;
};

/**
 * Formats milliseconds to a readable string
 */
export const formatTimeLimit = (ms: number): string => {
  if (ms >= 1000) {
    return `${(ms / 1000).toFixed(1)}s`;
  }
  return `${ms}ms`;
};

